/**
 * Shared MUI Menu paper styles for header menus (account, chat, row actions).
 * Uses logical positioning so RTL + MUI theme.direction behave correctly.
 */
export const HEADER_MENU_PAPER_SX = {
  overflow: "visible",
  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
  mt: 1.5,
  "& .MuiAvatar-root": {
    width: 32,
    height: 32,
    marginInlineStart: -0.5,
    marginInlineEnd: 1,
  },
  "&:before": {
    content: '""',
    display: "block",
    position: "absolute",
    top: 0,
    insetInlineEnd: 14,
    width: 10,
    height: 10,
    bgcolor: "background.paper",
    transform: "translateY(-50%) rotate(45deg)",
    zIndex: 0,
  },
};

export const HEADER_MENU_ANCHOR_ORIGIN = {
  vertical: "bottom",
  horizontal: "right",
};

export const HEADER_MENU_TRANSFORM_ORIGIN = {
  vertical: "top",
  horizontal: "right",
};
